import { motion } from "framer-motion";
import { BriefcaseBusiness, CalendarCheck, GraduationCap, Images, ListChecks, PenLine } from "lucide-react";

const features = [
  { icon: CalendarCheck, title: "Structured MBA weeks", description: "Plan lectures, assignments, deadlines, events, and self-care without losing the bigger picture." },
  { icon: BriefcaseBusiness, title: "Placement readiness", description: "Track profile-building goals, certifications, internships, live projects, and placement preparation in one place." },
  { icon: GraduationCap, title: "Academic control", description: "Organize case readings, presentations, quizzes, exams, and weekly priorities before they pile up." },
  { icon: ListChecks, title: "Committee clarity", description: "Compare committee responsibilities, benefits, and reality checks so you choose roles with intention." },
  { icon: Images, title: "Planner page archive", description: "Keep your MBA planner pages and progress snapshots together for quick review and reflection." },
  { icon: PenLine, title: "Reflection system", description: "Review what went well, what needs work, and what to focus on next week." },
];

export default function FeatureSection() {
  return (
    <section id="features" className="bg-[#FBF7EF] px-4 py-16 sm:px-5 md:px-10 md:py-20">
      <div className="mx-auto max-w-7xl">
        <div className="mb-10 max-w-4xl md:mb-12">
          <p className="font-body text-sm font-bold uppercase tracking-[0.28em] text-[#C99455]">Features</p>
          <h2 className="mt-3 font-heading text-3xl uppercase leading-[1.08] text-[#073C2F] sm:text-4xl md:text-6xl">
            A structured MBA planner for{" "}
            <span className="inline-block border border-[#D5AD76] bg-retro-yellow px-2 text-[#073C2F]">academics</span>{" "}
            <span className="inline-block border border-[#D5AD76] bg-retro-yellow px-2 text-[#073C2F]">placements</span>{" "}
            <span className="inline-block border border-[#D5AD76] bg-retro-yellow px-2 text-[#073C2F]">committees</span>{" "}
            and{" "}
            <span className="inline-block border border-[#D5AD76] bg-retro-yellow px-2 text-[#073C2F]">growth</span>
          </h2>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <motion.article
              key={feature.title}
              className="rounded-lg border border-[#D5AD76] bg-white/78 p-6 shadow-[0_16px_45px_rgba(7,60,47,0.08)] transition hover:-translate-y-1 hover:shadow-[0_24px_70px_rgba(7,60,47,0.14)]"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.45, delay: index * 0.04 }}
            >
              <div className="mb-5 grid h-12 w-12 place-items-center rounded-full bg-[#073C2F] text-[#FBF7EF]">
                <feature.icon size={22} />
              </div>
              <h3 className="font-heading text-xl uppercase text-[#073C2F]">{feature.title}</h3>
              <p className="mt-3 font-body text-sm leading-6 text-[#27463B]/82">{feature.description}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
